// react
import { ReactNode, useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { Link as RouterLink } from 'react-router-dom';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// mui
import { Link, LinkProps, Typography } from '@mui/material';

// props
export interface LinkInvoiceProps extends LinkProps {
	children?: ReactNode;
	invoiceNumber?: string | null;
	[x: string]: unknown;
}

export const LinkInvoice = ({ children, invoiceNumber, ...props }: LinkInvoiceProps) => {
	// hooks
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// vars
	let link = <Typography>{t('na')}</Typography>;

	if (children || invoiceNumber) {
		// vars
		const content = children || invoiceNumber;

		link = (
			<Link
				component={RouterLink}
				fontWeight={600}
				sx={{ wordBreak: 'break-word' }}
				to={`/project/${project?.idWbg}/spend-plans/invoices`}
				underline="hover"
				{...props}>
				{content}
			</Link>
		);
	}

	return link;
};
